import React from 'react'
import { toMonetaryFormat } from '../../../common/Utilities';

export default function ProjectDetailsRow({
  projectId, 
  projectName,
  rowDetails, 
}) {
  return (
    <tr>
      <td width="20%">{projectName}</td>
      <td width="10%" className={"align-right row-mandays-" + projectId}>
        {toMonetaryFormat(+rowDetails.mandays)}
      </td>
      <td width="10%" className={"align-right row-revenue-" + projectId}>
        {toMonetaryFormat(+rowDetails.revenue)}
      </td>
      <td width="10%" className={"align-right row-fully-loaded-cost-" + projectId}>
        {toMonetaryFormat(+rowDetails.fullyLoadedCost)}
      </td>
      <td width="10%" className={"align-right row-unloaded-cost-" + projectId}>
        {toMonetaryFormat(+rowDetails.unloadedCost)}
      </td>
      <td width="10%" className={"align-right row-external-cost-" + projectId}>
        {toMonetaryFormat(+rowDetails.externalCost)}
      </td>
      <td width="10%" className={"align-right row-total-cost-" + projectId}>
        {toMonetaryFormat(+rowDetails.totalCost)}
      </td>
      <td width="10%" className={"align-right row-profit-before-tax-" + projectId}>
        {toMonetaryFormat(+rowDetails.profitBeforeTax)}
      </td>
      <td width="10%" className={"align-right row-profit-net-after-tax-" + projectId}>
        {toMonetaryFormat(+rowDetails.profitNetofTax)}
      </td>
    </tr>
  )
}

